import React from 'react';
import { Alert } from 'react-bootstrap';

export const TerminationBanner = () => {
  const isPDAP = () => window.location.hostname.includes('principaldentalaccess');

  const terminationDetailsUrl = () => (
    isPDAP()
      ? 'https://www.principaldentalaccess.com/discontinuation-notice'
      : 'https://www.newdentalchoice.com/discontinuation-notice'
  );

  return (
    <Alert bsStyle="info">
      <p>
        {isPDAP() ? 'Principal® Dental Access Plan' : 'New Dental Choice'} will terminate on December 31, 2026.
        Existing members may continue using their benefits through that date.
        New enrollments are no longer being accepted.
        <a href={terminationDetailsUrl()} className="btn-link">
          View details
        </a>
      </p>
    </Alert>
  );
};

export default TerminationBanner;

